// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '980e87b366604f7252a6cbdddcd64eb32c28976a';
export const BUILD_NUMBER = '240';
export const BUILD_TIMESTAMP = '2026-09-16T04:48:49.021Z';
